import { useEffect, useState } from 'react';

/**
 * Śledzi, czy jesteśmy poniżej breakpointu mobile (max-width: 767.98px).
 * Reaguje na zmianę rozmiaru/orientacji (media query listener), więc komponent
 * przerysowuje się przy przejściu mobile↔desktop.
 */
export function useIsMobile(query = '(max-width: 767.98px)'): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
